import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from 'react-bootstrap/Alert';

interface AlertProps {
  translationKey: string;
  type: string;
}

const AlertMessage: React.FC<AlertProps> = ({ translationKey, type }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Alert key={type} variant={type}>
        {t(translationKey)}
      </Alert>
    </div>
  );
};

export default AlertMessage;
